import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroPretAPorter from './components/HeroPretAPorter';
import ServicesSection from './components/ServicesSection';
import HowItWorks from './components/HowItWorks';
import AlterationTestimonials from './components/AlterationTestimonials';
import BookingCalendar from './components/BookingCalendar';
import { useSEO } from '../../hooks/useSEO';
import { SchemaMarkup } from '../../components/SEOHead';

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Arreglos Prêt-à-porter',
  provider: {
    '@type': 'LocalBusiness',
    name: 'Anthony Sánchez Couture',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Rambla de Catalunya, 85, Principal - 2',
      addressLocality: 'Barcelona',
      addressRegion: 'Cataluña',
      postalCode: '08008',
      addressCountry: 'ES',
    },
  },
  areaServed: {
    '@type': 'City',
    name: 'Barcelona',
  },
  description: 'Arreglos profesionales de ropa en Barcelona. Bajos, ajustes de cintura, cambio de cremallera, confección de prendas y más. Calidad de alta costura en arreglos cotidianos.',
  serviceType: 'Arreglos y Confección',
  priceRange: '€€',
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Inicio',
      item: 'https://anthonysanchezc.com',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Prêt-à-porter',
      item: 'https://anthonysanchezc.com/pret-a-porter',
    },
  ],
};

export default function PretAPorter() {
  useSEO({
    title: 'Arreglos de Ropa Barcelona | Confección Prêt-à-porter | Anthony Sánchez Couture',
    description: 'Arreglos profesionales de alta calidad en Barcelona. Bajos, ajustes, cambios de cierre, confección de prendas. Servicio rápido y garantizado en el Eixample.',
    keywords: 'arreglos ropa Barcelona, arreglos alta costura, bajos pantalón, cambio cremallera, ajustes cintura, confección Barcelona, sastre Eixample',
    canonical: '/pret-a-porter',
    ogTitle: 'Arreglos de Ropa Barcelona — Calidad de Alta Costura',
    ogDescription: 'Arreglos profesionales en Barcelona con la precisión de la alta costura. Servicio rápido y garantizado.',
    ogType: 'website',
  });

  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={serviceSchema} />
      <SchemaMarkup schema={breadcrumbSchema} />
      <Navbar />
      <main>
        <HeroPretAPorter />
        <ServicesSection />
        <HowItWorks />
        <AlterationTestimonials />
        <BookingCalendar />
      </main>
      <Footer />
    </div>
  );
}